import React from "react";

import UpcomingRetreats from "../../retreats/UpcomingRetreats";

/* /retreats — the dated directory (spec 01, "Upcoming Retreats"). The
   evergreen cards stay on the home, about and resort pages. */
const ProductsMain = () => <UpcomingRetreats />;

export default ProductsMain;
